// extracted by mini-css-extract-plugin
export default {"notificationIcon":"Notifications_notificationIcon__k7EEM","notificationList":"Notifications_notificationList__IkIgY","titleMenu":"Notifications_titleMenu__hQsui"};